import { render, staticRenderFns } from "./OrganizationAddressTable.vue?vue&type=template&id=025f8747&"
import script from "./OrganizationAddressTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAddressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025f8747')) {
      api.createRecord('025f8747', component.options)
    } else {
      api.reload('025f8747', component.options)
    }
    module.hot.accept("./OrganizationAddressTable.vue?vue&type=template&id=025f8747&", function () {
      api.rerender('025f8747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/address/OrganizationAddressTable.vue"
export default component.exports